import * as tslib_1 from "tslib";
var ClientHandlerExtra_1;
import { jsonMember, jsonObject } from "typedjson";
import { DxObjectMapper } from "../../services/dx-object-mapper.service";
const cloneDeep = require('lodash.clonedeep');
/***
 *  дополнительная структура, используемая, совместно с {@link DxHttpErrorInterceptor.CLIENT_HANDLER_EXTRA_HEADER} как value,
 *  для обработки HttpErrorResponse
 */
let ClientHandlerExtra = ClientHandlerExtra_1 = class ClientHandlerExtra {
    constructor(fields) {
        if (fields)
            Object.assign(this, fields);
    }
    applyToOptions(serviceOptions) {
        const options = cloneDeep(serviceOptions);
        options.headers = options.headers.set(ClientHandlerExtra_1.CLIENT_HANDLER_EXTRA_HEADER, DxObjectMapper.serialize(this, ClientHandlerExtra_1));
        return options;
    }
};
/**
 * на бэке есть соответствующая константа, которая обрабатывается фильтром, выполняющим проброс значения обратно
 */
ClientHandlerExtra.CLIENT_HANDLER_EXTRA_HEADER = "Client-Handler-Extra";
tslib_1.__decorate([
    jsonMember({ constructor: Boolean, isRequired: false, emitDefaultValue: false }),
    tslib_1.__metadata("design:type", Boolean)
], ClientHandlerExtra.prototype, "ignoreGlobal", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Boolean, isRequired: false, emitDefaultValue: false }),
    tslib_1.__metadata("design:type", Boolean)
], ClientHandlerExtra.prototype, "ignore400", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: Boolean, isRequired: false, emitDefaultValue: false }),
    tslib_1.__metadata("design:type", Boolean)
], ClientHandlerExtra.prototype, "passBelow500", void 0);
ClientHandlerExtra = ClientHandlerExtra_1 = tslib_1.__decorate([
    jsonObject(),
    tslib_1.__metadata("design:paramtypes", [Object])
], ClientHandlerExtra);
export { ClientHandlerExtra };
